module.exports = __webpack_public_path__ + "static/media/cart-is-empty.922d19bd.png";